import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import Select from '../select';
import { setLanguage } from '../../model/iabp/actions';
import { ReactComponent as SBBGlobe } from '../../img/globe_210_large.svg';

import './LanguageSelect.scss';

const options = [
  { label: 'Deutsch', value: 'de' },
  { label: 'Français', value: 'fr' },
  { label: 'Italiano', value: 'it' },
  { label: 'English', value: 'en' },
];

const optionsMobile = [
  { label: 'DE', value: 'de' },
  { label: 'FR', value: 'fr' },
  { label: 'IT', value: 'it' },
  { label: 'EN', value: 'en' },
];

const selectStyles = (isAppWidthSmallerThanL) => {
  return {
    container: () => ({
      position: 'relative',
      height: 'calc(100% - 20px)',
      maxHeight: '38px',
      width: isAppWidthSmallerThanL ? '55px' : '120px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      marginRight: isAppWidthSmallerThanL ? '5px' : '0',
      color: 'grey',
    }),
    control: () => ({
      position: 'relative',
      height: '100%',
      width: '100%',
    }),
    valueContainer: () => ({
      position: 'relative',
      height: 'calc(100% - 10px)',
      width: '100%',
      cursor: 'pointer',
    }),
    indicatorsContainer: () => ({
      display: 'none',
    }),
    menu: (provided, state) => ({
      ...provided,
      width: '100%',
      color: state.selectProps.menuColor,
      border: '1px solid #aaa',
      borderRadius: 'none',
      borderTop: 'none',
      position: 'absolute',
      left: '0',
      margin: '0',
    }),
    option: (styles, state) => ({
      ...styles,
      padding: '10px 15px',
      color: state.isFocused ? '#c60018' : '#767676',
      '&:hover': {
        cursor: state.isSelected ? 'default' : 'pointer',
        color: state.isSelected ? '#767676' : '#c60018',
      },
      backgroundColor: 'white',
    }),
  };
};

const propTypes = {
  lng: PropTypes.string.isRequired,
  isAppWidthSmallerThanL: PropTypes.bool.isRequired,
};

const LanguageSelect = ({ lng, isAppWidthSmallerThanL }) => {
  const dispatch = useDispatch();

  const [inputValue] = useMemo(() => {
    return options.filter((opt) => opt.value === lng);
  }, [lng]);

  const onSelectChange = useCallback(
    (opt) => {
      dispatch(setLanguage(opt.value));
    },
    [dispatch],
  );

  return (
    <Select
      options={isAppWidthSmallerThanL ? optionsMobile : options}
      value={inputValue}
      styles={selectStyles(isAppWidthSmallerThanL)}
      selectLabel={
        <SBBGlobe focusable={false} className="tm-single-value-globe" />
      }
      onChange={onSelectChange}
    />
  );
};

LanguageSelect.propTypes = propTypes;
export default React.memo(LanguageSelect);
